var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modals"}},[(_vm.currentModal)?_c('div',{staticClass:"modals"},[_c('transition',{attrs:{"name":"modal"}},[_c(_vm.currentModal,{tag:"component",staticClass:"modal"})],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }